import { Role } from '../../Roles/Models/roles.model';

export interface EventSettings {
    enableCreation: boolean;
    maxParticipants: number;
    maxPollQuestions: number;
}

export enum AccountStatus {
    TRIAL = 'trial',
    ACTIVE = 'active',
    EXPIRED = 'expired',
    SUSPENDED = 'suspended'
}

export type AccountStatusType = 'trial' | 'active' | 'expired' | 'suspended';

export interface Profile {
    // Core user identification
    userId: string;
    userid: string; // Duplicate of userId - keep both for API compatibility
    
    // Basic user information
    firstName: string;
    lastName: string;
    email: string;
    
    // Student/Academic information
    studentId?: string;
    discipline?: string;
    
    // iClicker specific
    clickerId?: string;
    secKey?: string;
    registeredClickers?: any[] | null;
    
    // Account status and metrics
    courseCount?: number;
    status?: AccountStatusType;
    expirationDate?: number; // Unix timestamp
    expirationDateIso8601?: string | null;
    daysRemaining?: number;
    dateAdded?: number; // Unix timestamp
    
    // Access control and roles
    access: Role[]; // User's roles - required for authorization
    
    // Federation/SSO information
    federatedStudentMember?: boolean;
    federatedInstitutionId?: string | null;
    federatedInstitutionName?: string | null;
    
    // Feature settings
    eventSettings?: EventSettings;
    
    // Legacy/deprecated - mark as optional
    instructorRemote?: string; // Legacy property
}

export interface ProfileState {
    profile: Profile | null;
    isLoading: boolean;
    error: string | null;
}
  